import {format} from 'date-fns';

import type {BigCalendarEvent} from '../types/BigCalendarEvent';

/** Day and time of each boundary, so a bar spanning days states where it starts and ends. */
const TIME_SPAN_FORMAT = 'd.M. H:mm';

/**
 * The `d.M. H:mm – d.M. H:mm` label of a multi-day timed event. Shared by the all-day header and
 * the month view so the same event reads the same in every view.
 */
export const formatEventTimeSpan = (event: BigCalendarEvent) =>
  `${format(event.start, TIME_SPAN_FORMAT)} – ${format(event.end, TIME_SPAN_FORMAT)}`;
